<template>
    <div class="container-fluid"
    :style="{'background-image': 'url(' + require('../assets/bg2.jpg') + ')','background-size': 'cover','min-height':'600px'}">
    <!-- <div class="container-fluid"
    :style="{'background-color': '#fff','background-size': 'cover','min-height':'600px'}"> -->
    <nav class="navbar navbar-light bg-dark">
    <img
      src="../assets/technical-support.png"
      width="64"
      height="64"
      class="d-inline-block align-top"
      alt
    >
    <span style="font-size: 60px; line-height: 70px; color: #fff;" v-if="lang == 0">Refill</span>
    <span style="font-size: 60px; line-height: 70px; color: #fff;" v-if="lang == 1">เติมเงิน</span>
    <span style="font-size: 60px; line-height: 70px; color: #fff;" v-if="lang == 2">存款錢包</span>
    <img src="../assets/cancel.png" width="64" height="64" @click="back">
    </nav>
    <div class="row">
      <div class="col-4" >
        <div class="text-center text-white " style="font-size: 30px;">
          <b v-if="lang == 0">Current money</b>
          <b v-if="lang == 1">เงินปัจจุบัน</b>
          <b v-if="lang == 2">目前的錢</b>
        </div>
        <div class="input-balance-text">{{ shift_before }}</div>
        <div class="text-center text-white " style="font-size: 30px;">
          <b v-if="lang == 0">Amount of money</b>
          <b v-if="lang == 1">จำนวนเงินเติม</b>
          <b v-if="lang == 2">金錢數額</b>
        </div>
        <div class="input-balance-text">{{ shift_after }}</div>
        <div style="padding-top: 3px; padding-left: 0px;">
          <button class="btn btn-primary" style="font-size: 50px;width: 100%; margin-top: 2.5%; height: 80px; " @click="refillmonney(),Soundclick()">เติมเงิน</button>
        </div>
        <div style="padding-top: 3px; padding-left: 0px;">
          <button class="btn btn-danger" style="font-size: 50px;width: 100%; margin-top: 2.5%; height: 80px; " @click="resetmonney(),Soundclick()">รีเซ็ตเงิน</button>
        </div>
      </div>

      <div class="col-4">
        <div class="text-left text-white " style="font-size: 30px;">
          <b v-if="lang == 0">Coin 01</b>
          <b v-if="lang == 1">เหรียญ 1 บาท</b>
          <b v-if="lang == 2"></b>
        </div>
        <div class="input-w-text" v-if="select_option == 0" :style="{'border-color': 'green'}" @click="select_option = 0, Soundclick()">{{ parseInt(coins.C1) }}</div>
        <div class="input-w-text" v-if="select_option != 0" @click="select_option = 0, Soundclick()">{{ parseInt(coins.C1) }}</div>
        <div class="text-left text-white " style="font-size: 30px;">
          <b v-if="lang == 0">Coin 05</b>
          <b v-if="lang == 1">เหรียญ 5 บาท</b>
          <b v-if="lang == 2"></b>
        </div>
        <div class="input-w-text" v-if="select_option == 1" :style="{'border-color': 'green'}" @click="select_option = 1, Soundclick()">{{ parseInt(coins.C5) }}</div>
        <div class="input-w-text" v-if="select_option != 1" @click="select_option = 1, Soundclick()">{{ parseInt(coins.C5) }}</div>
        <div class="text-left text-white " style="font-size: 30px;">
          <b v-if="lang == 0">Coin 10</b>
          <b v-if="lang == 1">เหรียญ 10 บาท</b>
          <b v-if="lang == 2"></b>
        </div>
        <div class="input-w-text" v-if="select_option == 2" :style="{'border-color': 'green'}" @click="select_option = 2, Soundclick()">{{ parseInt(coins.C10) }}</div>
        <div class="input-w-text" v-if="select_option != 2" @click="select_option = 2, Soundclick()">{{ parseInt(coins.C10) }}</div>
      </div>
      <div class="col-4" style="margin-top: 5%;">
        <div class="row" style="padding-left: 5%; padding-right: 5%;">
          <div class="col p-0">
            <div class="btn-w-pad" style="border-right: 2px solid #fff;" @click="addAmount('1')">1</div>
          </div>
          <div class="col p-0">
            <div class="btn-w-pad" style="border-right: 2px solid #fff;" @click="addAmount('2')">2</div>
          </div>
          <div class="col p-0">
            <div class="btn-w-pad" @click="addAmount('3')">3</div>
          </div>
        </div>
        <div class="row" style="padding-left: 5%; padding-right: 5%;">
          <div class="col p-0">
            <div class="btn-w-pad" style="border-right: 2px solid #fff; border-top: 2px solid #fff;" @click="addAmount('4')">4</div>
          </div>
          <div class="col p-0">
            <div class="btn-w-pad" style="border-right: 2px solid #fff; border-top: 2px solid #fff;" @click="addAmount('5')">5</div>
          </div>
          <div class="col p-0">
            <div class="btn-w-pad" style=" border-top: 2px solid #fff;" @click="addAmount('6')">6</div>
          </div>
        </div>
        <div class="row" style="padding-left: 5%; padding-right: 5%;">
          <div class="col p-0">
            <div class="btn-w-pad" style="border-right: 2px solid #fff; border-top: 2px solid #fff;" @click="addAmount('7')">7</div>
          </div>
          <div class="col p-0">
            <div class="btn-w-pad" style="border-right: 2px solid #fff; border-top: 2px solid #fff;" @click="addAmount('8')">8</div>
          </div>
          <div class="col p-0">
            <div class="btn-w-pad" style="border-top: 2px solid #fff;" @click="addAmount('9')">9</div>
          </div>
        </div>
        <div class="row" style="padding-left: 5%; padding-right: 5%;">
          <div class="col p-0">
            <div class="btn-w-pad" style="border-right: 2px solid #fff; border-top: 2px solid #fff;" @click="addAmount('0')">0</div>
          </div>
          <div class="col p-0">
            <div class="btn-w-pad" style="border-top: 2px solid #fff;" @click="del">DEL</div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import $ from "jquery";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import api from "../service/services";
export default {
  data() {
    return {
    shift_before: 0,
    shift_after: 0,
    coins: {
        C10: 0,
        C5: 0,
        C2: 0,
        C1: 0,
      },
    number_id0: '',
    number_id1: '',
    number_id2: '',
    select_option: 0,
    step_refil: '',
    };
  },
  computed: {
    ...mapState([
      "UUID",
      "accessToken",
      "AuthenType",
      "status_refill",
      "shift_uuid",
      "isLoading",
      "lang"
    ]),
    ...mapMutations(["onMessageWs"])
  },
  methods: {
    back() {
      this.Soundclick()
      this.coins.C10 = 0
      this.coins.C5 = 0
      // this.coins.C2 = 0
      this.coins.C1 = 0
      // this.$router.push('/setting')
      // this.$router.push({
      //   name: 'Main'
      // })
      this.$router.go(-1)
    },
    addAmount (int) {
      switch (this.select_option) {
        case 0 :
          this.Soundclick()
          this.coins.C1 += int
          this.calAmount()
          break
        case 1 :
          this.Soundclick()
          this.coins.C5 += int
          this.calAmount()
        break
          case 2 :
          this.Soundclick()
          this.coins.C10 += int
          this.calAmount()
          break
        default:
          break
      }
    },
    del () {
      switch (this.select_option) {
        case 0 :
          this.Soundclick()
          if (parseInt(this.coins.C1) > 0) {
            if (this.coins.C1.length > 1) {
              this.coins.C1 = this.coins.C1.substring(
                0,
                this.coins.C1.length - 1
              )
              this.calAmount()
            } else {
              this.coins.C1 = ''
            }
          } else {
            this.coins.C1 = ''
          }
          break
        case 1 :
          this.Soundclick()
          if (parseInt(this.coins.C5) > 0) {
            if (this.coins.C5.length > 1) {
              this.coins.C5 = this.coins.C5.substring(
                0,
                this.coins.C5.length - 1
              )
            } else {
              this.coins.C5 = ''
            }
            this.calAmount()
          } else {
            this.coins.C5 = ''
          }
          break
        case 2 :
          this.Soundclick()
          if (parseInt(this.coins.C10) > 0) {
            if (this.coins.C10.length > 1) {
              this.coins.C10 = this.coins.C10.substring(
                0,
                this.coins.C10.length - 1
              )
              this.calAmount()
            } else {
              this.coins.C10 = ''
            }
          } else {
            this.coins.C10 = ''
          }
          break
        default:

        break
      }
    },
    resetmonney () {
      this.coins.C10 = 0
      this.coins.C5 = 0
      this.coins.C1 = 0
      this.calAmount()
    },
    calAmount () {
         this.shift_after = parseInt(this.coins.C10)+parseInt(this.coins.C5)+parseInt(this.coins.C1)
    },
    refillmonney () {
      this.$socket.sendObj({
          Device: 'host',
          type: 'request',
          command: 'refill',
          data: '{"v1\":'+parseInt(this.coins.C1)+', \"v2\":'+parseInt(this.coins.C2)+', \"v5\":'+parseInt(this.coins.C5)+', \"v10\":'+parseInt(this.coins.C10)+'}'
      })
      // console.log('{"v1\":'+parseInt(this.coins.C1)+', \"v2\":'+parseInt(this.coins.C2)+', \"v5\":'+parseInt(this.coins.C5)+', \"v10\":'+parseInt(this.coins.C10)+'}')
      this.$store.state.isLoading = true

      this.step_refil = setInterval(() => {
      if (this.$store.state.status_refill == 1) {
          this.refillTodata()
          clearInterval(this.step_refil)
        }
      }, 1000);
    },
    refillTodata () {
      const header = {
          headers: {
          'x-access-token': this.$store.state.accessToken
          // "x-access-token": '942be569a799418c9b4249dc964e7930'
          }
      }
      var playload = {
          shift_uuid: this.$store.state.shift_uuid,
          amount: parseInt(this.shift_after),
          payment: {
              b1000: 0,
              b500: 0,
              b100: 0,
              b50: 0,
              b20: 0,
              c10: parseInt(this.coins.C10),
              c5: parseInt(this.coins.C5),
              c2: parseInt(this.coins.C2),
              c1: parseInt(this.coins.C1),
              c050: 0,
              c025: 0
          }
      }
      // console.log("playload",playload)
      console.log(JSON.stringify(playload))
      api.shiftRefill (
          playload,
          header,
          result => {
              if(result.response == "success"){
                  Swal(
                      'แจ้งเตือน',
                      'เติมเงินสำเร็จ!!',
                      'success'
                  )
                  this.$store.state.status_refill == 0
                  this.getShiftStatus()
                  this.resetmonney()
                  this.$store.state.isLoading = false
              } else {
                  alert("error")
              }
          },
          error => {
          console.log("error",error)
          alert(error)
          }
      )
    },
    getShiftStatus() {
      const header = {
        headers: {
          "x-access-token": this.accessToken
        }
      };
      console.warn('shift header = ' + JSON.stringify(header))
      api.shitfStatus(
        header,
        result => {
          if (result.response == "success") {
          this.$store.state.shift_uuid = result.shift_uuid
          console.warn("getShift = " + this.$store.state.shift_uuid)
          this.shift_before = result.amount
          console.log("getShift = ",this.shift_before)
          }
        },
        error => {
          swal
            .fire({
              title: "Check Shift Status Error",
              text: error,
              type: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Reconnect !"
            })
            .then(result => {
              if (result.value) {
                this.getShiftStatus();
              } else {
                this.getShiftStatus();
              }
            });
        }
      );
    },
  },
  mounted() {
    console.log(this.select_option)
    this.getShiftStatus()
    if (this.$store.state.shift_uuid) {
      this.$socket.sendObj({
        Device: 'host',
        type: 'request',
        command: 'status'
      })
    } else {
      this.$router.push('/')
    }
  }
};
</script>

<style>
.input-w-text {
  width: 100%;
  height: 80px!important;
  background: #fff;
  border: 5px solid red;
  border-radius: 10px;
  font-size: 80px!important;
  line-height: 80px!important;
  text-align: right;
  margin-bottom: 10px;
}

.input-balance-text {
  width: 100%;
  height: 80px!important;
  background: #fff;
  border: 5px solid ;
  border-color: rgb(66, 175, 16)f;
  border-radius: 10px;
  font-size: 80px!important;
  line-height: 80px!important;
  text-align: center;
  margin-bottom: 10px;
}

.btn-w-pad {
  width: 100%;
  height: 80px;
  background: #1f1f14!important;
  font-size: 80px;
  line-height: 80px;
  color: #fff;
}

.btn-w-pad:active {
  background:#c2c2a3!important;
  border: 0px;
  color: #000;
}

.text-placeholder {
  position: absolute;
  top: 20px;
  right: 100px;
  font-size: 70px;
  color: rgb(173, 173, 173);
}

.bt-setting {
     width: 32.8%;
    height: 88px;
  margin: 0.23% 0%;
  font-size: 80px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  overflow: hidden;
}

.bt-setting span {
  line-height: 30px;
  margin: 0;
  padding: 0;
}

</style>


// WEBPACK FOOTER //
// src/components/Refill.vue